module.exports = __webpack_public_path__ + "static/media/img_cc.e92aff82.svg";